export default "__VITE_ASSET__dm6vlRH7__"